/**
 * The value a matched URL rule sends.
 *
 * A rule used to carry one fixed value, so a thank-you page shared by several
 * subscriptions reported one price for all of them, or none. With valueParam
 * the page says what was paid (/thanks?amount=49). The fixed value stays the
 * fallback: a page opened without the parameter, or with something that is not
 * an amount, still converts with the rule's own value instead of silently
 * sending a value of zero or no event at all.
 */

import type { TrackingRule } from "./types.js";

/** "49", "49.95" and "49,95". No thousands separators, no currency signs, nothing negative. */
const AMOUNT_PATTERN = /^\d{1,9}([.,]\d{1,4})?$/;

export function amountFromParam(raw: string | null): number | undefined {
  if (raw === null) return undefined;
  const text = raw.trim();
  if (!AMOUNT_PATTERN.test(text)) return undefined;
  return parseFloat(text.replace(",", "."));
}

export function ruleEventValue(rule: TrackingRule, pageUrl: string): number | undefined {
  if (!rule.valueParam) return rule.eventValue;
  let params: URLSearchParams;
  try {
    params = new URL(pageUrl).searchParams;
  } catch {
    return rule.eventValue;
  }
  const fromUrl = amountFromParam(params.get(rule.valueParam));
  if (fromUrl === undefined) return rule.eventValue;
  return fromUrl;
}
